export const HMS_CLIENT = 'HMS';
export const HMS_CLIENT_LIFERAY_FEATURE = 'hmsClient';
export const NORMAL_CLIENT_LIFERAY_FEATURE = 'normalClient';
export const HMS_CLIENT_LIFERAY_FEATURE_FOR_OFFERS = 'hmsClientForOffer';
export const NORMAL_CLIENT_LIFERAY_FEATURE_FOR_OFFERS = 'normalClientForOffer';
export const MADE_CREDIT_CARD_LIFERAY_FEATURE = 'madeCreditCardClient';
export const MOEN_LIFERAY_FEATURE = 'moenClient';
export const SIRVA_LIFERAY_FEATURE = 'sirvaClient';
export const SIRVA_CLIENT = 'SIRVA';
export const MOEN_CLIENT = "MOEN";
export const LIFERAY_FEATURE_OFF = 'featureOff';
export const DEDUCTIBLE_TEXT = "A deductible is collected up front for each item, when applicable. The deductible amount is dependent upon whether the service is a repair or a replacement.";
export const CONTRACT_STATUS_UPPER_ACTIVE = 'ACTIVE';
export const CONTRACT_STATUS_UPPER_INACTIVE = 'INACTIVE';
export const CONTRACT_STATUS_UPPER_CANCELED = 'CANCELED';
export const CONTRACT_STATUS_UPPER_EXPIRED = 'EXPIRED';
export const CONTRACT_STATUS_ACTIVE = 'Active';
export const CONTRACT_STATUS_INACTIVE = 'Inactive'
export const CONTRACT_STATUS_EXPIRED = 'Expired';
export const CONTRACT_STATUS_CANCELLED = 'Cancelled';
export const CONTRACT_STATUS_CANCELLATION_SCHEDULED = 'Cancellation scheduled';
export const CONTRACT_STATUS_TITLE_PLAN_CANCELLED = 'Plan cancelled';
export const CONTRACT_STATUS_TITLE_PLAN_EXPIRED = 'Plan expired';
// These fsm contract statuses are used in cancel flow
export const FSM_CONTRACT_STATUS_PENDING_CANCEL = 'PENDING CANCEL';
// this status is used when customer under stop bill flow cancels the contract
export const FSM_CONTRACT_STATUS_SCHEDULED_CANCEL = 'Cancellation Scheduled';

export const PLAN_DETAILS_INACTIVE_DISCLAIMER = 'planDetailsForInActiveDisclaimer';
export const PLAN_DETAILS_ACTIVE_DISCLAIMER = 'planDetailsForActiveDisclaimer';
export const PURCHASE_TYPE_CODE_SHW = 'SHW';
// Liferay operation item feature prefix for state-level hours of operation, e.g. 'stateClient_CA'.
// Not applied to RE (HMS), MadeCC or Moen clients.
export const STATE_CLIENT_LIFERAY_FEATURE_PREFIX = 'stateClient_';
